import React from "react";

import Tabs from "../../../app/UI/Tabs/Tabs";

import SMS from "./sms";
// import UnAllocatedTransactions from "./unallocated";

const index = () => {
  return (
    <Tabs>
      <div label={`Transactions`}>
        <SMS />
      </div>
      <div label={` `}>
        {/* <UnAllocatedTransactions /> */}
       {null}
      </div>
    </Tabs>
  );
};

export default index;
